import { formStarted, formSubmitFail, formSubmitSuccess } from "./analytics";

(function(window) {

  var trForm = {

    // Get all careers search forms
    init: function() {

      const trFormEl = document.getElementsByClassName('TrForm-formEl');

      if (!trFormEl.length) {
        return;
      }

      this.eachForm(trFormEl);
    },

    // Loop through each form on page and run blur/submit functions
    eachForm: function(forms) {
      for (let form of forms) {
        // disable html5 validation
        form.noValidate = true;
        const type = form.dataset.type;
        this.firstFocus(form);
        this.onSubmit(form);
        this.onBlur(form);
        this.countryOptin(form);
      };
    },

    // Watch for first focused element, send event
    firstFocus: function(form) {
      const self = this;
      const type = form.dataset.type;
      // Count all fields that are not of type hidden
      const numberOfFields = form.querySelectorAll('input:not([type="hidden"]), select, textarea').length;

      form.addEventListener('focus', function handler(e) {
        formStarted({ name: document.title, numberOfFields, type });
        this.removeEventListener('focus', handler, true);
      }, true);
    },

    // When user submits, get all required fields, test them and return values, if all values are true, submit form
    onSubmit: function(form, type) {
      const self = this;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const fields = form.querySelectorAll('[required]');
        const fieldGroups = form.querySelectorAll('.TrForm-groupRequired');
        const ajax = form.dataset.ajax;
        const post = form.getAttribute('action');
        const newsletter = form.dataset.newsletter;
        const type = form.dataset.type ? form.dataset.type : '';
        const allValidate = []

        for (let field of fields) {
          const fieldVal = field.value.trim();
          // Test fields return values
          const isValid = self.testFields(field.type, fieldVal);

          // Push test values to array
          allValidate.push({
            name: field.name,
            isValid
          });
          // Show notices accordingly
          self.showNotice(field, isValid);
        };

        // For all required grouped checkboxes/radios
        for(let fieldGroup of fieldGroups) {
          const oneChecked = fieldGroup.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked').length > 0;
          if(!oneChecked) {
            fieldGroup.classList.add('TrForm-validate--false');
          }
          allValidate.push({
            name: fieldGroup.querySelector("input").name,
            isValid: oneChecked
          });
        };

        // Are all fields validated?
        function validateAll(i) {
          return i.isValid;
        }
        const ready = allValidate.every(validateAll);

        // If using normal form action
        if (ready && post) {
          form.submit();
          formSubmitSuccess({ name: document.title, pathName: window.location.pathname, type });
        // If using data-ajax attr
        } else if (ready && ajax) {
          self.postAjax(form, ajax, type);
        // Submit fails because of validation, send event
        } else if(!ready) {
          formSubmitFail({
            invalidFieldNames: allValidate.filter(i => !i.isValid).map(i => i.name),
            name: document.title,
            pathName: window.location.pathname,
            type
          });
        }
      });
    },

    // Ajax post form data using fetch
    postAjax: function(form, ajax, type) {
      fetch(ajax, {
        method: 'POST',
        body: new FormData(form)
      }).then(function(res) {
          if (!res.ok) {
            throw Error(res.statusText);
          } else {
            form.style.display = 'none';
            form.nextElementSibling.style.display = 'block';
            form.nextElementSibling.scrollIntoView();

            const analyticsParameters = { name: document.title, pathName: window.location.pathname, type }
            const hashableIdentifierEl = form.querySelector("[data-hashable-identifier]");

            if (hashableIdentifierEl) {
              analyticsParameters.hashableIdentifier = hashableIdentifierEl.value;
            }

            formSubmitSuccess(analyticsParameters);
          }
      }).then(function(res) {
          console.log('ok');
      }).catch(function(err) {
          console.log(err);
      });
    },

    // When user leaves a field, check if field is required, if so test and return value
    onBlur: function(form) {
      const self = this;
      form.addEventListener('blur', function(e) {
        const field = e.target;
        const required = field.hasAttribute('required');
        const fieldVal = field.value ? field.value.trim() : '';
        const fieldType = field.type;

        if (required) {
          // Test fields return values
          const isValid = self.testFields(fieldType, fieldVal);
          // Show notices accordingly
          self.showNotice(field, isValid);
        }

        // if checkbox or radio blur see if any are checked
        if(fieldType === 'checkbox' || fieldType === 'radio') {
          const fieldGroups = form.querySelectorAll('.TrForm-groupRequired');
          for(let fieldGroup of fieldGroups) {
            const oneChecked = fieldGroup.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked').length > 0;
            if(!oneChecked) {
              fieldGroup.classList.remove('TrForm-validate--true');
              fieldGroup.classList.add('TrForm-validate--false');
            } else {
              fieldGroup.classList.remove('TrForm-validate--false');
              fieldGroup.classList.add('TrForm-validate--true');
            }
          };
        }
      }, true);
    },

    // Country opt-in for Canada/Germany
    countryOptin: function(form) {
      const countryField = form.querySelector('[name*=country]');
      const optInField = form.querySelector('[name*=emailOptIn]');

      if(countryField && optInField) {
        countryField.addEventListener('change', function(e) {
          const field = e.target;
          const fieldVal = field.value ? field.value.trim() : '';

          if(fieldVal === 'Canada' || fieldVal === 'Germany') {
            form.querySelector('.TrForm-Optin').style.display = 'block';
            form.querySelector('.TrForm-privacy').style.display = 'none';
            optInField.value = 'false';
          } else {
            form.querySelector('.TrForm-Optin').style.display = 'none';
            form.querySelector('.TrForm-privacy').style.display = 'block';
            optInField.value = 'undefined';
          }
        });

        optInField.addEventListener('change', function() {
          if (this.checked) {
            this.value = 'true';
          } else {
            this.value = 'false';
          }
        });
      }
    },

    // Test fields and return values function
    testFields: function(type, value) {
      if (type === 'text' && value !== '') {
        return true;
      } else if (type === 'email') {
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailPattern.test(value)) {
          return true;
        }
      } else if (type === 'tel' && value !== '') {
        return true;
      } else if (type === 'select-one' && value) {
        return true;
      } else if (type === 'textarea' && value !== '') {
        return true;
      }
    },

    // Hide or show notices function
    showNotice: function(field, isValid) {
      // Classes to add or remove
      const validFalse = 'TrForm-validate--false';
      const validTrue = 'TrForm-validate--true';

      // TODO:  clean this up
      if (isValid) {
        // If its a select menu target parent element otherwise target field element
        if (field.type === 'select-one') {
          field.parentElement.classList.remove(validFalse);
          field.parentElement.classList.add(validTrue);
        } else {
          field.classList.remove(validFalse);
          field.classList.add(validTrue);
        }
      } else {
        if (field.type === 'select-one') {
          field.parentElement.classList.remove(validTrue);
          field.parentElement.classList.add(validFalse);
        } else {
          field.classList.remove(validTrue);
          field.classList.add(validFalse);
        }
      }
    }

  };

  (function() {
    trForm.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/tr-form-validation.js